module.exports = __webpack_public_path__ + "img/guestPass.0b502dff.png";